/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardCompanySummaryComponentSupplyHistory from './DashboardCompanySummaryComponentSupplyHistory';
import TankInfo from './TankInfo';

/**
* The DashboardComponentGroupSummary model module.
* @module model/DashboardComponentGroupSummary
* @version 2020-12-7
*/
export default class DashboardComponentGroupSummary {
    /**
    * Constructs a new <code>DashboardComponentGroupSummary</code>.
    * @alias module:model/DashboardComponentGroupSummary
    * @class
    * @param groupId {Number} 
    * @param supplies {Array.<module:model/DashboardCompanySummaryComponentSupplyHistory>} 
    * @param thisYear {module:model/DashboardCompanySummaryComponentSupplyHistory} 
    * @param lastYear {module:model/DashboardCompanySummaryComponentSupplyHistory} 
    * @param tankInfo {module:model/TankInfo} 
    */

    constructor(groupId, supplies, thisYear, lastYear, tankInfo) {
        
        
        this['groupId'] = groupId;
        this['supplies'] = supplies;
        this['thisYear'] = thisYear;
        this['lastYear'] = lastYear;
        this['tankInfo'] = tankInfo;
        
    }

    /**
    * Constructs a <code>DashboardComponentGroupSummary</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardComponentGroupSummary} obj Optional instance to populate.
    * @return {module:model/DashboardComponentGroupSummary} The populated <code>DashboardComponentGroupSummary</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardComponentGroupSummary();
                        
            
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('supplies')) {
                obj['supplies'] = ApiClient.convertToType(data['supplies'], [DashboardCompanySummaryComponentSupplyHistory]);
            }
            if (data.hasOwnProperty('thisYear')) {
                obj['thisYear'] = DashboardCompanySummaryComponentSupplyHistory.constructFromObject(data['thisYear']);
            }
            if (data.hasOwnProperty('lastYear')) {
                obj['lastYear'] = DashboardCompanySummaryComponentSupplyHistory.constructFromObject(data['lastYear']);
            }
            if (data.hasOwnProperty('tankInfo')) {
                obj['tankInfo'] = TankInfo.constructFromObject(data['tankInfo']);
            }
        }
        return obj;
    }

    /**
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * @member {Array.<module:model/DashboardCompanySummaryComponentSupplyHistory>} supplies
    */
    'supplies' = undefined;
    /**
    * @member {module:model/DashboardCompanySummaryComponentSupplyHistory} thisYear
    */
    'thisYear' = undefined;
    /**
    * @member {module:model/DashboardCompanySummaryComponentSupplyHistory} lastYear
    */
    'lastYear' = undefined;
    /**
    * @member {module:model/TankInfo} tankInfo
    */
    'tankInfo' = undefined;




}
